// extracted by mini-css-extract-plugin
export default {"header":"Header_header__23ITg","logo":"Header_logo__D9fLO"};